export default __webpack_public_path__ + "static/media/freewheel-icon.b345deac.png";